const buildNotificationRows = (preferences, events, frequencies, resolveIcon) =>
  events.map((event) => {
    const row = preferences[event.id] || {}
    const rowDisabled = Boolean(row.disabled)

    const cells = { disabled: { checked: rowDisabled } }

    frequencies.forEach((frequency) => {
      const supported = event.frequencies.includes(frequency)
      cells[frequency] = {
        checked: supported && !rowDisabled && Boolean(row[frequency]),
        disabled: !supported,
      }
    })

    return {
      id: event.id,
      icon: resolveIcon(event),
      title: event.title,
      subtitle: event.subtitle,
      cells,
    }
  })

export default buildNotificationRows
